// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { MediaRequestSortKey, MediaRequestStatuses, MediaRequestSource } from "../models";
import { DeviceMediaRequest, IDeviceMediaRequest, TargetMediaResponse, ITargetMediaResponse, FileContentResult, IFileContentResult, MediaRequestResult, IMediaRequestResult, TimePeriod, ITimePeriod } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function createRequest(deviceId?: string, request?: DeviceMediaRequest): ApiResult<DeviceMediaRequest> {
	return post<IDeviceMediaRequest>(`/api/mediarequest/${ deviceId }/media-requests`, request).then(result => result === undefined ? undefined :  new DeviceMediaRequest(result));
}

export async function getRequest(deviceId?: string, requestId?: string): ApiResult<DeviceMediaRequest> {
	return get<IDeviceMediaRequest>(`/api/mediarequest/${ deviceId }/media-requests/${ requestId }`).then(result => result === undefined ? undefined :  new DeviceMediaRequest(result));
}

export async function getTargetMediaRequest(deviceId?: string, targetId?: string): ApiResult<TargetMediaResponse> {
	return get<ITargetMediaResponse>(`/api/mediarequest/${ deviceId }/by-target/${ targetId }`).then(result => result === undefined ? undefined :  new TargetMediaResponse(result));
}

export async function createRequestForTarget(deviceId?: string, targetId?: string): ApiResult<DeviceMediaRequest> {
	return post<IDeviceMediaRequest>(`/api/mediarequest/${ deviceId }/media-requests/${ targetId }/targets`).then(result => result === undefined ? undefined :  new DeviceMediaRequest(result));
}

export async function getRequestTargetsCSV(deviceId?: string, requestId?: string): ApiResult<FileContentResult> {
	return get<IFileContentResult>(`/api/mediarequest/${ deviceId }/media-requests/${ requestId }/targets`).then(result => result === undefined ? undefined :  new FileContentResult(result));
}

export async function getRequestRadarData(deviceId?: string, requestId?: string): ApiResult<FileContentResult> {
	return get<IFileContentResult>(`/api/mediarequest/${ deviceId }/media-requests/${ requestId }/radar`).then(result => result === undefined ? undefined :  new FileContentResult(result));
}

export async function getRequests(deviceId?: string): ApiResult<DeviceMediaRequest[]> {
	return get<IDeviceMediaRequest[]>(`/api/mediarequest/${ deviceId }/media-requests`).then(result => result === undefined ? undefined : result.map(o => new DeviceMediaRequest(o)));
}

export async function getRequestsInfiniteScroll(deviceId?: string, limit?: number, sortKey?: MediaRequestSortKey, sortDirection?: string, status?: MediaRequestStatuses, source?: MediaRequestSource, dateFrom?: Date, dateTo?: Date, cursor?: string): ApiResult<MediaRequestResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			status !== undefined ? `status=${status}` : undefined,
			source !== undefined ? `source=${source}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IMediaRequestResult>(`/api/mediarequest/${ deviceId }/media-requests/infinite-scroll${query}`).then(result => result === undefined ? undefined :  new MediaRequestResult(result));
}

export async function getEarliestVideo(deviceId?: string): ApiResult<TimePeriod> {
	return get<ITimePeriod>(`/api/mediarequest/${ deviceId }/media-requests/video/dvr-range`).then(result => result === undefined ? undefined :  new TimePeriod(result));
}

export async function deleteRequest(deviceId?: string, requestId?: string): ApiResult<DeviceMediaRequest> {
	return del<IDeviceMediaRequest>(`/api/mediarequest/${ deviceId }/media-requests/${ requestId }`).then(result => result === undefined ? undefined :  new DeviceMediaRequest(result));
}
